<template>
	<div>

		<div class="display_msg pos_inherit" grey-back v-if="!listItemObject.items.length && !loadMore">There are no transactions!</div>

		<div v-scroll="onScroll">

			<v-list two-line nopadding>

				<div v-for="(item, index) in listItemObject.items" :key="index">
					<v-list-tile class="right-subtitle-tile" @click="$root.fn_navigateToDisplayView(item.transactionListId, item.transactionId)">
					    <v-list-tile-content>
					      <v-list-tile-title class="mb-1">{{fn_transactionName(item.transactionListId)}}</v-list-tile-title>
					      <v-list-tile-sub-title class="mb-1">
					      	{{item.mergeTransactionNumber ? item.mergeTransactionNumber + ' | ' : ''}}{{item.transactionDate | moment("DD-MMM-YYYY")}}
					      </v-list-tile-sub-title>
					      <!-- <v-list-tile-sub-title>{{item.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title> -->
					    </v-list-tile-content>

					    <v-list-tile-action align-flex-end>
					    	<div class="light-opacity-color"><strong>&#8377; {{$root.numberToLocale(item.roundedAmount)}}</strong></div>

					    	<!-- <v-btn icon flat @click="fn_getBottomMenu(902, item.transactionId)" v-if="item.status">
					    		<v-icon>more_vert</v-icon>
					    	</v-btn> -->
					    	
					    	<div class="warning-label" v-if="!item.status">Cancelled</div>
					    </v-list-tile-action>
					</v-list-tile>

					<v-divider v-if="listItemObject.items.length-1 != index"></v-divider>
				</div>

				<!-- <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
					<div slot="no-more"></div>
					<div slot="no-results"></div>
				</infinite-loading> -->

				<div padding-all-16 center-align v-if="loadMore">
					<v-progress-circular indeterminate color="primary"></v-progress-circular>
				</div>


			</v-list>
		</div>
	</div>
</template>

<script>

// import InfiniteLoading from 'vue-infinite-loading';
const transactionForms = require('../../../../../config.js').configs.transactionForms;

	export default{
		props:['partyId'],
		components: {
		    // InfiniteLoading,
		},
		data(){
			return{
				toolbarTitle:null,
				listItemObject:{"items":[], "totalCount":0},
				searchValue:'',
				infiniteId: +new Date(),
				startIndex:0,
				scrollPositionTop:0,
				selectedItemId:null,
				// loading:false
				loadMore: false
			}
		},
		methods:{

			onScroll: function(event){
				var element = event.target;
			    if (element.documentElement.scrollHeight - element.documentElement.scrollTop - 20 <= element.documentElement.clientHeight)
			    {
			        console.log('scrolled');
			        if(this.listItemObject.items.length < this.listItemObject.totalCount){
			        	this.fn_loadItems();
			        }
			    }
			},

			fn_transactionName: function(transactionListId){
				for(let i=0; i<transactionForms.length; i++){
					if(transactionForms[i].id == transactionListId){
						return transactionForms[i].title;
					}
				}
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				if(menuAction=='edit'){
					this.$router.push('/transactions/sales/saleinvoice/items/'+this.selectedItemId+'/edit');
				}
			},

			fn_itemClick: function (itemId) {
				this.$router.push('/transactions/sales/saleinvoice/items/'+itemId);
			},

			// fn_getBottomMenu: function (elementId, itemId) {
			// 	itemId ? this.selectedItemId = itemId : '';

			// 	let bottomMenu;

			// 	if(elementId == bottomSheetMenu.toolBar.Id){
			// 		bottomMenu = {"BottomMenu": [menuItem.help]};
			// 	}
			// 	else if(elementId == bottomSheetMenu.masterListItems.Id){
			// 		bottomMenu = {"BottomMenu": [menuItem.edit]};
			// 	}
				
			// 	this.setBottomMenu(tagId, bottomMenu, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 			},
			// 			onError: function (error) {
			// 				console.log(error);
			// 			}
			// 		}
			// 	)
			// },

			// infiniteHandler($state) {
		 //    	let filterObject = {};
			// 	filterObject.partyId = this.partyId;
			// 	filterObject.limit = 10;
			// 	filterObject.startIndex = this.startIndex;
			// 	filterObject.search = this.searchValue.toLowerCase();
			// 	this.loading = true;
			// 	let self = this;
			// 	this.getItems("AllTransactionListByParty", filterObject, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 				let responseJson = JSON.parse(response);
			// 				self.listItemObject.totalCount = responseJson.totalCount;

			// 				for(let i in responseJson.items){
			// 					self.listItemObject.items.push(responseJson.items[i]);	
			// 				}

			// 				self.startIndex = self.listItemObject.items.length;
							
			// 				if(self.listItemObject.items.length < self.listItemObject.totalCount){
			// 					// self.listItemObject.items = self.listItemObject.items.concat(responseJson.items);
			// 					// self.startIndex = self.listItemObject.items.length;
			// 					$state.loaded();
			// 				}
			// 				else {
   //        						$state.complete();
   //      					}

   //      					self.loading = false;
			// 			},
			// 			onError: function (error) {
			// 				console.log(error);
			// 				self.loading = false;
			// 			}
			// 		}
			// 	)
		 //    }

			fn_loadItems: function() {
				this.loadMore = true;
		    	let filterObject = {};
				filterObject.partyId = this.partyId;
				filterObject.limit = 50;
				filterObject.startIndex = this.startIndex;
				filterObject.search = this.searchValue.toLowerCase();
				this.loading = true;
				let self = this;
				this.getItems("AllTransactionListByParty", filterObject, 
					{
						onSuccess: function (response) {
							console.log(response);
							let responseJson = JSON.parse(response);
							self.listItemObject.totalCount = responseJson.totalCount;

							for(let i in responseJson.items){
								self.listItemObject.items.push(responseJson.items[i]);	
							}

							self.startIndex = self.listItemObject.items.length;
							self.loadMore = false;

        					// self.loading = false;
						},
						onError: function (error) {
							console.log(error);
							self.loadMore = false;
							// self.loading = false;
						}
					}
				)
		    }


		},
		mounted: function(){
			this.fn_loadItems();
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/masters/forms/ledgers/display_tabs/transactions.vue